'use client';

import { BannerAdSlot } from '@/app/_components/ads';
import { AD_PLACEMENTS } from '@/app/_components/ads/adPlacements';

export const HomeFeedListAdBanner = () => (
  <BannerAdSlot
    {...AD_PLACEMENTS.homeFeedBanner}
    wrapperClassName="bg-Gray-white py-20"
  />
);
